import I18n from "./vendor/I18n";

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    let translator = new I18n;

    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    let ajaxCall = $('.ajax-call');

    ajaxCall.on('click', function () {
        $.ajax({
            type: 'POST',
            url: $(this).attr('data-href'),
            data: {_token: $(this).attr('data-token')},
            success: function (data) {
                Swal.fire({
                    title: data.msg,
                    showCancelButton: false,
                    confirmButtonText: translator.trans('script.Continue'),
                    icon: 'info'
                }).then((result) => {
                    location.reload();
                });
            }
        });
    })

    let gls = $('.ajax-gls');

    gls.on('change', function () {
        let elementId = '#gls' + $(this).attr('data-id');
        if ($(this).val()) {
            $.ajax({
                type: 'POST',
                url: $(this).attr('data-href'),
                data: {
                    _token: $(this).attr('data-token'),
                    shop_id: $(this).val()
                },
                success: function (data) {
                    if (parseInt(data['gls'], 10) === 1) {
                        $(elementId).html('<span class="badge badge-success">' + translator.trans('script.Yes') + '</span>');
                    } else {
                        $(elementId).html('<span class="badge badge-danger">' + translator.trans('script.No') + '</span>');
                    }

                }
            });
        } else {
            $(elementId).html('');
        }
    })

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: translator.trans('script.Are you sure you want to delete this item?'),
            showCancelButton: true,
            confirmButtonText: translator.trans('script.Confirm Delete'),
            cancelButtonText: translator.trans('script.Cancel'),
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            let actionText = $(this).attr('data-action-text') === '' ? '' : $(this).attr('data-action-text');

            Swal.fire({
                title: translator.trans('script.Are you sure you want to do this?'),
                text: actionText,
                showCancelButton: true,
                confirmButtonText: translator.trans('script.Continue'),
                cancelButtonText: translator.trans('script.Cancel'),
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
            /**
             * Add an 'are you sure' pop-up to any button/link
             */
            e.preventDefault();

            Swal.fire({
                title: translator.trans('script.Are you sure you want to do this?'),
                showCancelButton: true,
                confirmButtonText: translator.trans('script.Continue'),
                cancelButtonText: translator.trans('script.Cancel'),
                icon: 'info',
            }).then((result) => {
                result.value && window.location.assign($(this).attr('href'));
            });
        })
        .on('submit', 'form[name=action-item]', function (e) {
            e.preventDefault();

            let formValues = $(this).serializeArray();
            let isModal = false;

            for (let i = 0; i < formValues.length; i++) {
                if (formValues[i].name === 'operation_id') {
                    let operations = [2, 3];
                    if (operations.includes(parseInt(formValues[i].value, 10))) {
                        isModal = true;
                        let actionText = $(this).attr('data-action-text') === '' ? '' : $(this).attr('data-action-text');

                        Swal.fire({
                            title: translator.trans('order_item_reject.Reason for rejection'),
                            text: actionText,
                            input: 'select',
                            inputOptions: {
                                1: translator.trans('order_item_reject.Size incorrect'),
                                2: translator.trans('order_item_reject.Colour incorrect'),
                                3: translator.trans('order_item_reject.Damaged product'),
                                4: translator.trans('order_item_reject.Faulty stock'),
                                5: translator.trans('order_item_reject.Other')
                            },
                            inputValue: parseInt(formValues[i].value, 10) === 2 ? '4' : '5',
                            showCancelButton: true,
                            confirmButtonText: translator.trans('script.Continue'),
                            cancelButtonText: translator.trans('script.Cancel'),
                            icon: 'question',
                        }).then((result) => {
                            if (result.isConfirmed === true) {
                                let reasonType = parseInt(result.value, 10);
                                $(this).append('<input type="text" name="reason_type" value="' + reasonType + '" />');

                                if (reasonType === 5) {
                                    Swal.fire({
                                        title: translator.trans('order_item_reject.Comment'),
                                        input: 'textarea',
                                        showCancelButton: true,
                                        confirmButtonText: translator.trans('script.Continue'),
                                        cancelButtonText: translator.trans('script.Cancel'),
                                    }).then((result) => {
                                        if (result.isConfirmed === true) {
                                            $(this).append('<textarea  name="comment">' + result.value + '</textarea>');
                                            this.submit();
                                        } else {
                                            enableSubmitButtons($(this));
                                        }
                                    });
                                } else {
                                    this.submit();
                                }
                            } else {
                                enableSubmitButtons($(this));
                            }
                        });
                    }
                    break;
                }
            }

            if (isModal === false) {
                this.submit();
            }
        });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="' + hash + '"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    if ($('#service-dashboard div').hasClass("progressbar")) {
        setTimeout(function () {
            window.location.reload();
        }, 30000)
    }

    /* The order list is updated every 10 minutes */
    if ($('#order-list').hasClass("is-user")) {
        setTimeout(function () {
            window.location.reload();
        }, 600000)
    }

    $("div.progressbar").progressbar({
        value: false
    });

    if (typeof pickDay !== "undefined" && typeof addDays !== "undefined") {
        $.datepicker.regional['hu'] = {
            closeText: 'bezár',
            prevText: 'vissza',
            nextText: 'előre',
            currentText: 'ma',
            monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június',
                'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún',
                'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
            dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
            dayNamesShort: ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
            dayNamesMin: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
            weekHeader: 'Hét',
            dateFormat: 'yy-mm-dd',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: true,
            yearSuffix: ''
        };
        $.datepicker.setDefaults($.datepicker.regional['hu']);

        $('.datepicker').datepicker({
                minDate: pickDay,
                maxDate: "+" + addDays + "D",
                beforeShowDay: function(date) {
                    var day = date.getDay();
                    return [(day != 0 && day != 6)];
                }
            });
    }
});
